import axios from 'axios'
import { readCsrfToken } from '../../shared/csrf.js'
import { getBrowserTimezone } from '../../shared/utils/browserTimezone.js'

const withTimezone = (payload) => {
  const timezone = getBrowserTimezone()

  return timezone ? { ...payload, timezone } : payload
}

const client = axios.create({
  headers: {
    'Accept':       'application/json',
    'Content-Type': 'application/json',
  },
})

client.interceptors.request.use((config) => {
  config.headers['X-CSRF-TOKEN'] = readCsrfToken()

  return config
})

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 419 && !error.config?.skipReloadOn419) {
      window.location.reload()
    }
    return Promise.reject(error)
  }
)

export const authApi = {
  startLogin: (identifier, guard = 'web') =>
    client.post('/auth/start', { identifier, guard }),

  getSessionStatus: () => client.get('/auth/session-status'),

  sendMagicLink: (identifier, channel = null, guard = 'web') => {
    const payload = { identifier, guard }
    if (channel) payload.channel = channel
    return client.post('/auth/magic-link/send', payload)
  },

  verifyPassword: (identifier, password, guard = 'web', trust = false) =>
    client.post(
      '/auth/password/verify',
      withTimezone({ identifier, password, guard, trust }),
      { skipReloadOn419: true },
    ),

  sendPasswordResetLink: (identifier, channel, guard = 'web') =>
    client.post('/auth/password/reset-link/send', { identifier, channel, guard }),

  resetPassword: (token, password, password_confirmation, guard = 'web') =>
    client.post('/auth/password/reset', withTimezone({ token, password, password_confirmation, guard })),

  sendCode: (method, identifier, guard = 'web') =>
    client.post('/auth/mfa/send', { method, identifier, guard }),

  verifyCode: (code, identifier, guard = 'web', trust = false) =>
    client.post('/auth/mfa/verify', withTimezone({ code, identifier, guard, trust })),

  sendClassicPhoneCode: (identifier, guard = 'web') =>
    client.post('/auth/classic/phone/send', { identifier, guard }),

  verifyClassicPhoneCode: (code, identifier, guard = 'web') =>
    client.post('/auth/classic/phone/verify', { code, identifier, guard }),

  trustDevice: (trust) =>
    client.post('/auth/device/trust', { trust }),
}
